import React, { useState } from 'react';
import { AddContainer, Component3, Texts, HeaderPart, FooterPart, SaveButton, CancelButton } from './Style';
import InputSelect from 'src/components/shared/Form/Select';
import theme from 'src/config/theme';
import { alpha } from '@mui/material';
import InputComponent from 'src/components/shared/Form/Input';
import NumberInput from 'src/components/shared/Form/Number';
import DateTimePicker from 'src/components/App/DatePicker/index.js';
import { ReactComponent as CloseIcon } from '../../../../../../src/assets/images/close-circle.svg';
import { ReactComponent as AddIcon } from '../../../../../../src/assets/images/add-square.svg';
import ButtonComponent from 'src/components/shared/Button';
import { palette, shadows } from 'src/config/theme.js';
import { postTreatmentRequest } from 'src/modules/app/store/appActions';
import { useSelector, useDispatch } from "react-redux";
import { useParams } from 'react-router-dom';
import { Formik, Form } from "formik";
import * as Yup from "yup";
import useAppointmentDetails from '../../UseAppointmentDetails';
import dayjs from 'dayjs';
import toast from 'src/utils/toast';
import useResponsive from 'src/components/hooks/useResponsive';


function TreatmentTabForm({ onClose, fetchTreatments }) {
    const { isMobile, isTablet, isDesktop } = useResponsive();
    const dispatch = useDispatch();
    const { PatientId, user, clinicId, appointmentId } = useAppointmentDetails();
    console.log("here is appointment id from treatment", appointmentId)
    const Types = [
        { label: 'Visiting', value: 'visiting' },
        { label: 'Sitting', value: 'sitting' },
    ];
    const Days = [
        { label: 'Monday', value: 'mon' },
        { label: 'Tuesday', value: 'Tue' },
        { label: 'Wednesday', value: 'Wed' },
        { label: 'Thursday', value: 'Thu' },
        { label: 'Friday', value: 'fri' },
        { label: 'Saturday', value: 'sat' },
        { label: 'Sunday', value: 'sun' },
    ]
    const validationSchema = Yup.object().shape({
        name: Yup.string()
            .required('Treatment name is required'),

        total: Yup.number()
            .required('Total visits are required')
            .positive('Total visits must be a positive number'),

        treatmentType: Yup.string()
            .required('Treatment type is required'),

        days: Yup.array()
            .when('treatmentType', {
                is: 'isVisiting',
                then: Yup.array().min(1, 'At least one day must be selected'),
            }),

        date: Yup.date()
            .nullable()
            .when('treatmentType', {
                is: '!isVisiting',
                then: Yup.date().required('First treatment date is required'),
            }),

        time: Yup.date()
            .required('Time slot is required')
            .nullable()
            .typeError('Please select a valid time slot'),
    });

    const handleSubmit = async (values, { resetForm }) => {
        const remaining = Number(values.total);
        const isVisiting = values.treatmentType === 'visiting';

        try {
            const formattedTime = dayjs(values.time).format('HH:mm');

            const treatmentData = {
                treatmentType: values.treatmentType,
                name: values.name,
                total: values.total,
                remaining: Number(values.total),
                ...(isVisiting
                    ? {
                        days: values.days,
                        time: formattedTime,
                    }
                    : {
                        dateTimes: [
                            {
                                date: dayjs(values.date).format('YYYY-MM-DD'),
                                time: formattedTime,
                            },
                        ],
                    }),
                tokenAppointment: appointmentId,
                patient: PatientId,
                clinic: clinicId,
                user,
            };

            const response = await new Promise((resolve, reject) => {
                dispatch(postTreatmentRequest(treatmentData, resolve, reject));
            });
            console.log("treatment response here", response);
            if (response?.id && fetchTreatments) {
                fetchTreatments();
            }
            toast.success(response.message || 'Treatment Created Successfully')
            onClose();

            resetForm();


        }
        catch (error) {
            console.log(error.message || 'Failed to add notes', { variant: 'error' });
        }

    }
    return (
        <>
            <Formik
                enableReinitialize={true}
                initialValues={{
                    name: '',
                    total: '',
                    remaining: '',
                    treatmentType: Types[0].value,
                    days: [],
                    time: dayjs(),
                    date: dayjs(),
                }}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {({ values, errors, touched, handleBlur, handleSubmit, handleChange, setFieldValue }) => (
                    <Form>
                        <HeaderPart>
                            Add Treatment
                            <CloseIcon width={isMobile || isTablet ? 18 : 24}
                                height={isMobile || isTablet ? 18 : 24} onClick={onClose} style={{ cursor: 'pointer' }} />
                        </HeaderPart>
                        <AddContainer>
                            <Component3>
                                <Texts>Type</Texts>
                                <InputSelect
                                    name="treatmentType"
                                    showNone={false}
                                    value={values.treatmentType}
                                    options={Types}
                                    onChange={(value) => setFieldValue('treatmentType', value)}
                                    variant="outlined"
                                    onBlur={handleBlur}
                                    error={touched.treatmentType && Boolean(errors.treatmentType)}
                                    helperText={touched.treatmentType && errors.treatmentType}

                                    sx={{

                                        boxShadow: theme.shadows[1],
                                        '& .MuiOutlinedInput-root': {
                                            height: '52px',
                                            display: 'flex',
                                            alignItems: 'center',

                                            borderRadius: '12px',
                                        },
                                    }}
                                />
                            </Component3>
                            <Component3>
                                <Texts>Treatment Name</Texts>
                                <InputComponent
                                    name="name"
                                    value={values.name}
                                    onChange={handleChange}
                                    placeholder="Enter"
                                    variant="outlined"
                                    onBlur={handleBlur}
                                    error={touched.name && Boolean(errors.name)}
                                    helperText={touched.name && errors.name}
                                    sx={{
                                        backgroundColor: theme.palette.gery.white,
                                        boxShadow: theme.shadows[1],
                                        '& .MuiOutlinedInput-root': {
                                            // padding: '10px 18px',
                                            borderRadius: '12px',
                                            height: '52px',

                                        },
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            border: `1px solid ${alpha(theme.palette.gery.black, 0.14)}`,
                                        },
                                    }}
                                />
                            </Component3>
                            <Component3>
                                <Texts>Total Visits</Texts>
                                <NumberInput
                                    name="total"
                                    fullWidth
                                    width={isMobile || isTablet ? 'auto' : '430px'} height="50px"
                                    value={values.total}
                                    onChange={(val) => setFieldValue('total', val)}
                                    onBlur={handleBlur}
                                    error={touched.total && Boolean(errors.total)}
                                    helperText={touched.total && errors.total}
                                />
                            </Component3>

                            {values.treatmentType === 'visiting' ? (
                                <>
                                    <Component3>
                                        <Texts>When visit</Texts>
                                        <InputSelect
                                            name="days"
                                            placeholder="Select Multiple Days"
                                            multiple={true}
                                            value={values.days}
                                            options={Days}
                                            onChange={(value) => setFieldValue('days', value)}
                                            variant="outlined"
                                            onBlur={handleBlur}
                                            error={touched.days && Boolean(errors.days)}
                                            helperText={touched.days && errors.days}
                                            sx={{
                                                // width: '200px',
                                                boxShadow: theme.shadows[1],
                                                '& .MuiOutlinedInput-root': {
                                                    height: '52px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    // border: `1px solid ${alpha(theme.palette.gery.black, 0.14)}`,
                                                    borderRadius: '12px',
                                                },
                                            }}


                                        />
                                    </Component3>
                                    <Component3>
                                        <Texts>Time slot</Texts>
                                        <DateTimePicker
                                            name="time"
                                            value={values.time}
                                            onChange={(value) => setFieldValue('time', value)}

                                            type="time"
                                        />

                                    </Component3>
                                </>
                            ) : <>
                                <Component3>
                                    <Texts>First Treatment Date</Texts>
                                    <DateTimePicker
                                        name="date"
                                        value={values.date}
                                        onChange={(value) => setFieldValue('date', value)}
                                        fullWidth
                                        type="date"
                                        sx={{
                                            height: "52px",
                                            borderRadius: '12px',
                                            // padding: '10px 16px',
                                        }}
                                    />
                                </Component3>
                                <Component3>
                                    <Texts>First Treatment Time slot</Texts>
                                    <DateTimePicker
                                        name="time"
                                        value={values.time}
                                        onChange={(value) => setFieldValue('time', value)}
                                        type="time"
                                    />

                                </Component3>
                            </>}

                        </AddContainer>
                        <FooterPart >
                            <CancelButton
                                variant="none"
                                startIcon={<CloseIcon width={isMobile || isTablet ? 18 : 24}
                                    height={isMobile || isTablet ? 18 : 24} />}
                                onClick={onClose}
                            >
                                Cancel
                            </CancelButton>
                            <SaveButton
                                type="submit"
                                variant="outlined"
                                startIcon={<AddIcon width={isMobile || isTablet ? 18 : 24}
                                    height={isMobile || isTablet ? 18 : 24} sx={{ color: palette.primary.main }} />}

                            // onClick={handleSubmit ? () => handleSubmit() : null}
                            >
                                Save
                            </SaveButton>
                        </FooterPart>
                    </Form>
                )}
            </Formik>
        </>
    )
}

export default TreatmentTabForm
